const datax = {
    "design for customer centricity": [
        {
            cap: 1,
            title:"Solution Video: Connected Digital Innovation",
            description:"Get the right products and services to market quickly, all while improving quality and customer satisfaction.",
            text:"Watch the video",
            url:"https://www.oracle.com/explore/unlock-continuous-innovation/uci-develop-digital-innovation-video?lb-mode=overlay&source=:ow:o:h:mt:::RC_WWMK210324P00050:NA21_SCM_Q4_C24_M0601_S031YZ18_DS282_T34&intcmp=:ow:o:h:mt:::RC_WWMK210324P00050:NA21_SCM_Q4_C24_M0601_S031YZ18_DS282_T34&topic=Develop"
        },
        {
            cap: 1,
            title:"Elgin Sweeper Company delivers predictive customer experiences",
            description:" Elgin Sweeper Company delivers predictive customer experiences with IoT and augmented reality.",
            text:"Watch the video",
            url:"https://video.oracle.com/detail/video/6154742806001/century-old-elgin-sweeper-company-stays-competitive-with-oracle-cx?autoStart=true&q=Elgin" 
        },        
    ],
    "design for sustainability":[
        {
            cap: 2,
            title:"Building a More Sustainable Future - Oracle",
            description:"See how Oracle solutions help the company and its customer make a difference in sustainability and the environment.",
            text:"Read the report",
            url:"https://www.oracle.com/a/ocom/docs/sustainability-at-oracle.pdf" 
        },
    ],
    "design for lifecycle": [
        {   
            cap: 3,
            title:"Guide: Product Lifecycle Management",
            description:"Get the right tools to ensure product success throughout the lifecycle.",
            text:"Download the solution guide",
            url:"https://www.oracle.com/explore/unlock-continuous-innovation/uci-develop-plm-solution-guide?topic=Develop" 
        },
    ],
    "design with supply chain": [
        {  
            cap: 4,
            title:"Get data flow whenever and wherever a good idea happens",
            description:"Pull the entire supply chain together to quickly develop, test, and move forward with winning innovation.",
            text:"Watch the video",
            url:"https://www.oracle.com/scm/product-lifecycle-management/innovation/?bcid=6246280169001" 
        },
        {
            cap: 4,
            title:"Analyst Research: How Digital Transformation is Driving Change for Manufacturers",
            description:"Understand the benefits and challenges of digital transformation from thought leaders and practitioners.",
            text:"Read the report",
            url:"https://www.oracle.com/explore/unlock-continuous-innovation/uci-serve-fs-research?lb-mode=overlay&source=:ow:o:h:mt:::RC_WWMK210324P00050:NA21_SCM_Q4_C24_M0601_S031YZ18_DS282_T34&intcmp=:ow:o:h:mt:::RC_WWMK210324P00050:NA21_SCM_Q4_C24_M0601_S031YZ18_DS282_T34&topic=Serve"
        }
    ],
    "project selection and management": [
        {
            cap: 5,
            title:"Get great ideas to market - fast",
            description:"Discover how the most innovative companies grow faster than the market by doing these 5 things right.",
            text:"Read the whitepaper",
            url:"https://www.oracle.com/explore/unlock-continuous-innovation/bm-bmi-great-ideas?topic=Develop"
        },
    ],
    "product data management":[
        {
            cap: 6,
            title:"Analyst Research: View the transformation of product design report",
            description:"Use data to fuel new product innovation and improve efficiency.",
            text:"Download the report",
            url:"https://www.oracle.com/explore/unlock-continuous-innovation/oracle-digital-transformation?topic=Develop" 
        },
        {
            cap: 6,
            title:"Analyst Research: How to Unlock Continuous Innovation in a Digitally Transforming World",
            description:"Get advice from industry experts on getting the right innovations to market on time and every time.",
            text:"Read the analyst report",
            url:"https://www.oracle.com/explore/unlock-continuous-innovation/uci-fs-research?lb-mode=overlay&source=:ow:o:h:mt:::RC_WWMK210324P00050:NA21_SCM_Q4_C24_M0601_S031YZ18_DS282_T34&intcmp=:ow:o:h:mt:::RC_WWMK210324P00050:NA21_SCM_Q4_C24_M0601_S031YZ18_DS282_T34&topic=Unlock%20Continuous%20Innovation"
        } 
    ]
};

export default datax;